import { filterAutoFocusable as e } from "./DOMutils.js";
import { pickFirstFocus as a } from "./firstFocus.js";
import { getDataset as c } from "./is.js";
var s = function (u) {
    return function (o) {
      var r,
        t = (r = c(o)) === null || r === void 0 ? void 0 : r.autofocus;
      return (
        // @ts-expect-error
        o.autofocus ||
        //
        t !== void 0 && t !== "false" ||
        //
        u.indexOf(o) >= 0
      );
    };
  },
  m = function (u, o, r) {
    var t = u.map(function (f) {
        var i = f.node;
        return i;
      }),
      n = e(t.filter(s(r)));
    return n && n.length ? a(n) : a(e(o));
  };
export { m as pickAutofocus };